module.exports = __webpack_public_path__ + "static/media/Element_9_treatments.9eea71c3.svg";